import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../store'
export const loaderSlice = createSlice({
    name: 'loader',
    initialState: {
        show: false,
    },
    reducers: {
        SHOW_LOADER: (state): void => {
            state.show = true
        },
        HIDE_LOADER: (state): void => {
            state.show = false
        },
    },
})

export const { SHOW_LOADER, HIDE_LOADER } = loaderSlice.actions

export const selectLoader = (state: RootState) => state.loader

export default loaderSlice.reducer
